const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCcX(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "yg07m52foa"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 1694",
    style: {
      fill: "none"
    },
    d: "M0 0h36v36H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#yg07m52foa)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 1360",
    d: "M30 29H6a4 4 0 0 1-4-4V11a4 4 0 0 1 4-4h24a4 4 0 0 1 4 4v14a4 4 0 0 1-4 4M6 9a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V11a2 2 0 0 0-2-2z",
    style: {
      fill: "current"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 1361",
    d: "M16.787 23.6a6.762 6.762 0 0 1-3.047.593 5.091 5.091 0 0 1-3.819-1.461A5.339 5.339 0 0 1 8.5 18.835a5.713 5.713 0 0 1 1.589-4.171 5.467 5.467 0 0 1 4.08-1.622 7.148 7.148 0 0 1 2.622.418v2.035a4.886 4.886 0 0 0-2.49-.636 3.4 3.4 0 0 0-2.618 1.062 3.9 3.9 0 0 0-.986 2.768 3.768 3.768 0 0 0 .938 2.681 3.254 3.254 0 0 0 2.5 1 5.113 5.113 0 0 0 2.659-.7z",
    style: {
      fill: "current"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 1362",
    d: "M26.941 23.6a6.762 6.762 0 0 1-3.047.593 5.091 5.091 0 0 1-3.819-1.461 5.339 5.339 0 0 1-1.425-3.894 5.713 5.713 0 0 1 1.589-4.171 5.467 5.467 0 0 1 4.08-1.622 7.148 7.148 0 0 1 2.622.418v2.035a4.886 4.886 0 0 0-2.49-.636 3.4 3.4 0 0 0-2.618 1.062 3.9 3.9 0 0 0-.986 2.768 3.768 3.768 0 0 0 .938 2.681 3.254 3.254 0 0 0 2.5 1 5.113 5.113 0 0 0 2.659-.7z",
    style: {
      fill: "current"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 319",
    transform: "translate(5.751 5.5)",
    style: {
      stroke: "#ff3e72",
      strokeLinecap: "round",
      strokeWidth: 2,
      fill: "none"
    },
    d: "M24.499 0 0 24.5"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCcX);
export default __webpack_public_path__ + "static/media/icon-cc-x.02e166458fe7a1685266902096c3121a.svg";
export { ForwardRef as ReactComponent };